/** @format */
import React, { useEffect, useState, useCallback, createRef } from 'react';
import { Button, Grid, CircularProgress, Chip, useMediaQuery } from '@mui/material';
import { useStyles } from './style';
import { validator } from 'myValidation';
import {
    InputV2,
    AutocompleteV,
    DatePickerPod,
    RadioGroupPod,
    SelectV,
    Icons
} from 'components';
import { DatePicker } from 'components/LegacyPickers';
import { useFormContext } from 'react-hook-form';
import createToast from 'components/Toast/Toast';
import { useGuildsList } from 'hooks';
import { CustomTable } from './index';

const IssueInvoicContent = ({ editData, loadContractsLoading, setSelectedProducts, selectedProducts, setVoucherHashs, voucherHashs, changeNeedProfile, setTotalPrice, activeStep, defualPaymentType }) => {
    // -- STATE --//
    const [voucherHash, setVoucherHash] = useState('');
    const [fileCounter, setFileCounter] = useState(1);
    const inputRef = createRef();

    const methods = useFormContext();
    const { getGuildsList, guildListLoading, businessGuildsList } = useGuildsList();
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:600px)');


    /**
  * مقادیر مربوط به ابزار پرداخت
  */
    const PAYMENT_TOOLS = [
        {
            value: 'NOT_SELECTED',
            label: 'انتخاب نشده',
        },
        {
            value: 'IS_CHEQUE',
            label: 'چک دیجیتال',
        },
        {
            value: 'IS_LOAN',
            label: 'پرداخت اقساطی',
        },

    ];

    const fieldStyle = {
        paddingLeft: matches ? '8px' : '0',
    };


    useEffect(() => {
        getGuildsList();
    }, []);


    useEffect(() => {
        if (editData.length === 0) return;
        methods.setValue('guildCode', editData.guildCode);
        methods.setValue('billNumber', editData.billNumber);
        methods.setValue('description', editData.description);
        methods.setValue('voucher', editData.voucher);
        methods.setValue('postVoucherEnabled', editData.postVoucherEnabled);
        methods.setValue('verificationNeeded', editData.verificationNeeded);

    }, [editData]);

    /**
* محاسبه خروجی محصولات 
*/
    useEffect(() => {
        const data = methods.getValues();
        const total = selectedProducts?.map(e => ({
            total: (parseFloat(e.price) * e.quantity) - e.discount
        }));
        if (total !== undefined) {
            let totalAmount = total.reduce((accumulator, current) => accumulator + current.total, 0);
            let result = (totalAmount * (data?.preferredTaxRate / 100)) + totalAmount;
            setTotalPrice(parseInt(Math.ceil(result)))
        }
        //اگر لیست جدول خالی بود مقدار کل باید صفر باشد 
        if (selectedProducts?.length === 0) setTotalPrice(0)
    }, [selectedProducts, activeStep]);


    /**
* فیلد های مربوط به فاکتور را ثبت میکند
*/
    useEffect(() => {
        methods.register('guildCode');
        methods.register('deadline');
        methods.register('voucher');
        methods.register('description');
        methods.register('preferredTaxRate');
        return () => {
            methods.unregister('guildCode');
            methods.unregister('deadline');
            methods.unregister('voucher');
            methods.unregister('description');
            methods.unregister('preferredTaxRate');
        };
    }, [methods.register, methods.unregister]);


    /**
* افزودن بن تخفیف به لیست بن های انتخاب شده
*/
    const onAddVoucher = useCallback(
        (valueFromFile) => {
            const normalizer = (text = '') =>
                text
                    .split(',')
                    .map((v) => v.trim())
                    .filter((v) => !!v);

            setVoucherHashs((state) => [...state, ...normalizer(valueFromFile || voucherHash)]);
            setVoucherHash('');
        },
        [voucherHash, setVoucherHash],
    );

    /**
* حذف بن تخفیف به لیست بن های انتخاب شده
*/

    const onDeleteVoucher = useCallback(
        (v) => {
            setVoucherHashs((state) => state.filter((vo) => vo !== v));
        },
        [setVoucherHashs],
    );

    /**
* بارگزاری فایل text برای بن تخفیف
*/

    const onSelectFile = (e) => {
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            const file = e.target.files[0];
            if (!file) {
                createToast('خطا', 'ابتدا یک فایل .txt انتخاب کنید', 'danger');
            }
            setFileCounter((state) => state + 1);
            const reader = new FileReader();
            const textFile = /text.*/;

            if (file?.type?.match(textFile)) {
                reader.onload = function (event) {
                    try {
                        const lines = event.target.result?.split?.('\n').join(',');
                        onAddVoucher(lines);
                    } catch (error) { }
                };
            } else {
                createToast('خطا', 'فایل انتخاب شده معتبر نمی‌باشد', 'danger');
            }
            reader.readAsText(file);
        } else {
            createToast('خطا', 'مرورگر شما از این ویژگی پشتیبانی نمی‌کند', 'danger');
        }
    };


    /**
  * چک میکند آیا متن وارد شده شامل تگ اسکریپت هست یا خیر !
  */
    const checkScriptTagInText = (values) => {
        const v = validator.matches(
            String(values).trim() ?? '',
            /<[^>]*>/g,
        );
        return v;
    }

    // -- LOCAL VARIABLES --//
    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            item
            xs={12}
            className={classes.root}

        >
            <Grid item xs={12} sm={6} lg={3} >
                <InputV2
                    name="billNumber"
                    label="شماره قبض"
                    errors={methods.formState.errors}
                    register={methods.register}
                    control={methods.control}
                    rules={['isNotContainTag']}
                />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
                <DatePickerPod label="تاریخ سررسید" showAsterisk >
                    <DatePicker
                        variant="inline"
                        name="deadline"
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                        value={methods.watch('deadline')}
                        onChange={(e) => methods.setValue('deadline', e)}
                        minDate={new Date()}
                        style={{ marginBottom: '8px' }}
                    />
                </DatePickerPod>
            </Grid>
            <Grid item xs={12}  >
                <Grid item xs={12} sm={6} lg={6}>
                    <AutocompleteV
                        placeholder="جستجو و انتخاب کنید..."
                        control={methods.control}
                        errors={methods.formState.errors}
                        register={methods.register}
                        name="guildCode"
                        startIcon={<Icons icon="ReceiveSquare" color="#fff" size="23" />}
                        label="محل واریز درآمد"
                        list={businessGuildsList}
                        preventAddCustomOption
                        disableClearable
                        rules={['required']}
                        loading={guildListLoading}
                        onChange={(event, newValue) => handleGuildChange(newValue)}

                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <CustomTable
                    methods={methods}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                />
            </Grid>
            <Grid item md={6} xs={12} style={fieldStyle}>
                <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="توضیحات"
                    name="description"
                    rules={['isNotContainTag']}
                    register={methods.register}
                    control={methods.control}
                    defaultValue=""
                />
            </Grid>

            <Grid item xs={12}>
                <div className={classes.invoiceExtrasRow}>
                    <div className={classes.taxField}>
                        <InputV2
                            fullWidth
                            errors={methods.formState.errors}
                            rules={['required']}
                            currency
                            label="مالیات"
                            minimumValue="0"
                            maximumValue="100"
                            currencyText="درصد"
                            name="preferredTaxRate"
                            register={methods.register}
                            control={methods.control}
                            forceValue={methods.watch('preferredTaxRate')}
                        />
                    </div>
                    <div className={classes.voucherControl}>
                        <InputV2
                            placeholder="می‌توانید بن ها را با کاراکتر ',' از هم جدا کنید"
                            fullWidth
                            dir="ltr"
                            name="voucher_temp"
                            label="بن تخفیف"
                            tooltip="بن تخفیف‌هایی که می‌توانند برای پرداخت این فاکتور استفاده شوند را وارد کنید یا فایل txt حاوی کدها را وارد کنید."
                            value={voucherHash}
                            forceValue={voucherHash}
                            removeLeftRadius
                            englishNumber
                            onChangeValue={(ev) => {
                                setVoucherHash(ev?.target?.value);
                            }}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={!voucherHash}
                            className={classes.addBusinessBtn}
                            onClick={() => {
                                if (checkScriptTagInText(voucherHash)) {
                                    return createToast(
                                        'خطا',
                                        'بن تخفیف وارد شده معتبر نیست.',
                                        'danger',
                                    );
                                }

                                onAddVoucher();
                            }}
                        >
                            افزودن
                        </Button>
                    </div>
                    <div className={classes.uploadControl}>
                        <input
                            key={fileCounter}
                            hidden
                            accept="text/plain"
                            id="raised-button-file-voucher"
                            type="file"
                            multiple={false}
                            onChange={onSelectFile}
                            ref={inputRef}
                        />
                        <Button
                            startIcon={<Icons icon="UploadText" color="#2b3990" size="23" />}
                            variant="outlined"
                            color="primary"
                            type="button"
                            onClick={() => inputRef.current?.click?.()}
                        >
                            بارگذاری فایل .TXT
                        </Button>
                    </div>

                    {!!voucherHashs[0] && (
                        <div className={classes.voucherChips}>
                            {voucherHashs.map((item, index) => (
                                <Chip
                                    className={classes.chip}
                                    key={index}
                                    label={item}
                                    variant="outlined"
                                    onDelete={() => onDeleteVoucher(item)}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </Grid>


            <Grid item xs={12} lg={3} className={classes.radioBtn}>
                <RadioGroupPod
                    label="مشتری می تواند بعدا کد تخفیف روی فاکتور اعمال کند."
                    control={methods.control}
                    name="postVoucherEnabled"

                    onChangeradio={(e) => {

                        methods.setValue('postVoucherEnabled', e);
                    }}
                    options={[
                        { value: 'true', label: 'بله', placement: 'end' },
                        { value: 'false', label: 'خیر', placement: 'end' },
                    ]}
                />
            </Grid>
            <Grid item xs={12} lg={3} className={classes.radioBtn}>
                <RadioGroupPod
                    label="پرداخت فاکتور توسط مشتری نیازمند تایید شما نیز می باشد."
                    control={methods.control}
                    name="verificationNeeded"
                    onChangeradio={(e) => {
                        methods.setValue('verificationNeeded', e);
                    }}
                    options={[
                        { value: 'true', label: 'بله', placement: 'end' },
                        { value: 'false', label: 'خیر', placement: 'end' },
                    ]}
                />
            </Grid>
            <Grid item xs={12} style={{ position: 'relative' }} >
                <Grid item xs={12} md={3} spacing={4} style={{ position: 'relative' }} >
                    <SelectV
                        name="type"
                        options={PAYMENT_TOOLS}
                        label="ابزار پرداخت فاکتور را انتخاب کنید:"
                        required
                        forceValue={defualPaymentType}
                        errors={methods.formState.errors}
                        fullWidth
                        disabled={!!loadContractsLoading}
                        onChangeFunc={(k, e) => {
                            changeNeedProfile(e?.target?.value)
                        }}
                    />
                    {!!loadContractsLoading && (
                        <div className={classes.isLoading}>
                            <CircularProgress size={20} />
                        </div>
                    )}
                </Grid>
            </Grid>
        </Grid >
    );
};

export default IssueInvoicContent;
